module.exports = __webpack_public_path__ + "assets/pie_us-4bdc3f.svg";